module.exports = __webpack_public_path__ + "img/test-image-2@3x.90d1efb5.png";